import { all } from "redux-saga/effects";
import { hoaDonDienTuSaga } from "./hoaDonDienTuSaga";
import { kyHieuHoaDonSaga } from "./kyHieuHoaDonSaga";

export default function* hoaDonSagaWrapper() {
  yield all([hoaDonDienTuSaga(), kyHieuHoaDonSaga()]);
}
